import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { STORY_STATUSES, type AdminStory } from '@fois-utsavvoice/shared';
import { listStories } from '../api/stories.js';
import { useAuth } from '../auth/AuthContext.js';
import { AdminNav } from '../components/AdminNav.js';
import { PageShell } from '../components/PageShell.js';

export function AdminStoriesPage() {
  const auth = useAuth();
  const [items, setItems] = useState<AdminStory[]>([]);
  const [status, setStatus] = useState('');
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    if (!auth.tokens) {
      return;
    }
    listStories(auth.tokens.idToken, status || undefined)
      .then((page) => {
        setItems(page.items);
        setError(undefined);
      })
      .catch(() => setError('Stories could not be loaded.'));
  }, [auth.tokens, status]);

  return (
    <PageShell>
      <AdminNav />
      <section className="card">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h1 className="heading-xl text-crimson">Customer stories</h1>
          <Link className="btn-primary" to="/admin/stories/new">
            Create story invitation
          </Link>
        </div>
        <p className="mt-3 text-charcoal">
          Review text testimonials and consent before anything is approved for later publication.
        </p>
        <label className="field-label mt-4" htmlFor="story-status">
          Status
        </label>
        <select
          id="story-status"
          className="field-input max-w-xs"
          value={status}
          onChange={(event) => setStatus(event.target.value)}
        >
          <option value="">All</option>
          {STORY_STATUSES.map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        {error ? (
          <p className="mt-4 text-sm font-semibold text-crimson" role="alert">
            {error}
          </p>
        ) : null}
        <div className="mt-6 overflow-x-auto">
          <table className="min-w-full text-left text-sm">
            <thead>
              <tr className="border-b border-linen">
                <th className="py-2 pr-4">Product</th>
                <th className="py-2 pr-4">Order</th>
                <th className="py-2 pr-4">Consent</th>
                <th className="py-2 pr-4">Status</th>
                <th className="py-2 pr-4">Created</th>
                <th className="py-2"> </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.storyId} className="border-b border-linen">
                  <td className="py-3 pr-4">{item.productName}</td>
                  <td className="py-3 pr-4">{item.orderReference ?? '—'}</td>
                  <td className="py-3 pr-4">{item.consentLevel ?? '—'}</td>
                  <td className="py-3 pr-4">{item.status}</td>
                  <td className="py-3 pr-4">{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td className="py-3">
                    <Link
                      className="font-semibold text-crimson underline"
                      to={`/admin/stories/${item.storyId}`}
                    >
                      Review
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && !error ? (
            <p className="mt-4 text-charcoal/80">No stories yet.</p>
          ) : null}
        </div>
      </section>
    </PageShell>
  );
}
